import React, { useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import { motion, AnimatePresence } from "framer-motion";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  // Prevent body scroll when sidebar is open
  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "auto";
  }, [sidebarOpen]);

  return (
    <AnimatePresence>
      {sidebarOpen && (
        <>
          {/* Backdrop */}
          <Backdrop
            as={motion.div}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => toggleSidebar(false)}
          />

          {/* Sidebar */}
          <SidebarWrapper
            as={motion.aside}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <CloseBtn onClick={() => toggleSidebar(false)}>×</CloseBtn>
            <UlWrapper>
              <li>
                <NavLink
                  to="home"
                  smooth={true}
                  duration={600}
                  offset={-70}
                  spy={true}
                  onClick={() => toggleSidebar(false)}
                >
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="about"
                  smooth={true}
                  duration={600}
                  offset={-70}
                  spy={true}
                  onClick={() => toggleSidebar(false)}
                >
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="services"
                  smooth={true}
                  duration={600}
                  offset={-70}
                  spy={true}
                  onClick={() => toggleSidebar(false)}
                >
                  Services
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="contact"
                  smooth={true}
                  duration={600}
                  offset={-70}
                  spy={true}
                  onClick={() => toggleSidebar(false)}
                >
                  Contact Us
                </NavLink>
              </li>
            </UlWrapper>
          </SidebarWrapper>
        </>
      )}
    </AnimatePresence>
  );
}

/* =================== Styles =================== */

const SidebarWrapper = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  width: 70%;
  max-width: 320px;
  height: 100%;
  background: #0a192f;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5rem;
  z-index: 1100;
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 2rem;
  color: #fff;
  background: transparent;
  border: none;
  cursor: pointer;
`;

const UlWrapper = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  text-align: center;

  li {
    margin: 1.5rem 0;
  }
`;

const NavLink = styled(Link)`
  text-decoration: none;
  font-size: 1.2rem;
  color: #fff;
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    color: #64ffda;
  }
`;
